import Pill from "glesys-controlpanel/components/pill";
import PillError from "glesys-controlpanel/components/pill/error";
import PillInfo from "glesys-controlpanel/components/pill/info";
import PillWarning from "glesys-controlpanel/components/pill/warning";
import { and, eq, not } from "ember-truth-helpers";
import { t } from "ember-intl";

<template>
  <div ...attributes>

    {{#if (eq @domain.state "glesys-ok")}}
      <Pill data-test-dns-domain-pill-ok @text="Glesys" />
    {{/if}}
    {{#if (eq @domain.state "glesys-expired")}}
      <PillError data-test-dns-domain-pill-expired @text="Glesys - {{t 'dns.domain.state.expired'}}" />
    {{/if}}
    {{#if (and (not @domain.isAutoRenewalActive) (eq @domain.state "glesys-expiring"))}}
      <PillWarning
        data-test-dns-domain-pill-expiring
        @text="Glesys - {{t 'dns.domain.state.expiring' date=@domain.registrarinfo.expire}}"
      />
    {{/if}}
    {{#if (and @domain.isAutoRenewalActive (eq @domain.state "glesys-expiring"))}}
      <PillInfo
        data-test-dns-domain-pill-renewing
        @text="Glesys - {{t 'dns.domain.state.renews' date=@domain.renewalDate}}"
      />
    {{/if}}
    {{#if (eq @domain.state "glesys-waiting")}}
      <Pill
        data-test-dns-domain-pill-waiting
        data-test-state-waiting
        @text="Glesys - {{t 'dns.domain.state.waiting'}}"
      />
    {{/if}}
    {{#if (eq @domain.state "glesys-failed")}}
      <PillError data-test-dns-domain-pill-failed @text="Glesys - {{t 'dns.domain.state.failed'}}" />
    {{/if}}
    {{#if (eq @domain.state "glesys-unknown")}}
      <Pill data-test-dns-domain-pill-unknown @text="Glesys" />
    {{/if}}
  </div>
</template>
